export default __webpack_public_path__ + "static/media/CircularXXWeb-Book.f1485158.woff";